<div class="outer">

    <div class="section">
        <div><fa-icon [icon]="faCircleNotch" [spin]="true" size="1x" style="font-size:28px;color: rgb(150, 150, 150)"></fa-icon></div>
        <div style="margin: 20px 0">Öppna Swish och följ instruktioner för betalning.</div>
        <button *ngIf="showOpenSwish && !swishOpened" mat-raised-button color="primary" (click)="openSwish()">Öppna Swish</button>
        <button *ngIf="swishOpened" mat-raised-button color="primary" (click)="cancelSwish()">Avbryt</button>
    </div>

</div>